<template>
  <div id="duckathon-app">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useAuthStore } from '@/stores/authStore';

const authStore = useAuthStore();

onMounted(() => {
  authStore.initAuth();
});
</script>

<style scoped>
#duckathon-app {
  width: 100%;
  height: 100%;
}
</style>
